import { useEffect, useMemo, useState } from 'react';
import { getEmptyFormContextData } from './form-context-data';
import { LocalStorageData } from './types';
import { FIRST_STEP } from './step-configuration';

const LOCAL_STORAGE_FORM_KEY = 'form-data';

export function readFromLocalStorage(): LocalStorageData {
  return (
    JSON.parse(localStorage.getItem(LOCAL_STORAGE_FORM_KEY) || 'null') || {
      data: getEmptyFormContextData(),
      step: FIRST_STEP,
    }
  );
}

export function writeToLocalStorage(data: LocalStorageData) {
  localStorage.setItem(LOCAL_STORAGE_FORM_KEY, JSON.stringify(data));
}

export function clearLocalStorage() {
  localStorage.removeItem(LOCAL_STORAGE_FORM_KEY);
}

export function useLocalStorage() {
  const initialData = useMemo(() => readFromLocalStorage(), []);
  const [data, setData] = useState(initialData);

  useEffect(() => {
    const onVisibilityChange = () => {
      if (!document.hidden) {
        setData(readFromLocalStorage());
      }
    };

    document.addEventListener('visibilitychange', onVisibilityChange, false);
    return () =>
      document.removeEventListener('visibilitychange', onVisibilityChange);
  }, []);

  return data;
}
